import React from 'react';
import { injectIntl } from 'react-intl';
import utils from '../../../duck/utils';
import '../TableComponent.scss';
import VTODroppableCellBoxContainer from './VTODroppableCellBoxContainer';
import text from 'strings/text';

const VTOTableRow = (props) => {
 
  const rowOfVTOs = utils.getRowOfVTOToDisplay(props.shifts, props.weekRangeStart, props.enableVTO);

  const getCellElement = (date, shiftsForDay) => {
    return  <VTODroppableCellBoxContainer
                 user={props.user} 
                 date={date.clone()} 
                 shiftsForDay={shiftsForDay} 
                 weekRangeStart={props.weekRangeStart}
                 selectedDateToAddShift={props.selectedDateToAddShift} 
                 selectedShiftToViewDetail = {props.selectedShiftToViewDetail}
                 isCopyingShift={props.isCopyingShift} 
                 shiftToCopy={props.shiftToCopy}
                 allUsers = {props.allUsers} />
  }

  const col1 = props.weekRangeStart.clone();
  const col2 = col1.clone().add(1, 'days');
  const col3 = col1.clone().add(2, 'days');
  const col4 = col1.clone().add(3, 'days');
  const col5 = col1.clone().add(4, 'days');
  const col6 = col1.clone().add(5, 'days');

  const totalVTOHours = props.vtoHoursResult["WeekTotalHours"]?.toFixed(2) || 0 

  return (
    <thead>
    <tr className="calendar-row">
      <td className="shift-row__owner-cell">
        <div className='head-cell'>
            <img className='os-icon' src='/icons/vto-sign.svg'/>
              <div className='right-column'>
                <label className='os-label'> {text.voluntaryTimeOff} </label>
                <label className='os-hours'> {totalVTOHours} h</label>
              </div>
          </div>
      </td>

      {getCellElement(col1, rowOfVTOs[1])}
      {getCellElement(col2, rowOfVTOs[2])}
      {getCellElement(col3, rowOfVTOs[3])}
      {getCellElement(col4, rowOfVTOs[4])}
      {getCellElement(col5, rowOfVTOs[5])}
      {getCellElement(col6, rowOfVTOs[6])}
      {getCellElement(props.weekRangeEnd.clone(), rowOfVTOs[7])}

    </tr>
    </thead>
  );
};

export default injectIntl(VTOTableRow);
